import { render, staticRenderFns } from "./reCaptcha.vue?vue&type=template&id=702d8c6b&"
import script from "./reCaptcha.vue?vue&type=script&lang=js&"
export * from "./reCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('702d8c6b')) {
      api.createRecord('702d8c6b', component.options)
    } else {
      api.reload('702d8c6b', component.options)
    }
    module.hot.accept("./reCaptcha.vue?vue&type=template&id=702d8c6b&", function () {
      api.rerender('702d8c6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/reCaptcha.vue"
export default component.exports